import { produce } from 'immer';
import merge from 'lodash/merge';
import { ESpecialOfferType } from '../api/models/payment/eligible-categories.types';
import { initialRootState } from '../initialRootState';
import { ESpecialOfferActionType, TSpecialOfferAction } from './actions';

export interface ISpecialOfferState {
  type?: ESpecialOfferType;
  startDate?: string;
  endDate?: string;
  paymentUrl?: string; // Web only
  callDone?: boolean;
}

export const specialOfferReducer = (
  currentState = initialRootState.specialOffer,
  action: TSpecialOfferAction
): Partial<ISpecialOfferState> =>
  produce(currentState, draft => {
    switch (action.type) {
      case ESpecialOfferActionType.GET_CALL_DONE:
        merge(draft, { callDone: true });
        break;
      case ESpecialOfferActionType.GET_SUCCESS:
        merge(draft, action.payload);
        break;
    }
  });
